import React, { useLayoutEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Home from './components/Home';
import About from './components/About';
import Projects from './components/Projects';
import Footer from './components/Footer';
import ProjectDetails from './components/ProjectDetails';
import Scope from './components/Scope';
import Contact from './components/Contact';
import './App.css';

// Page wrapper component to ensure scroll reset
const PageWrapper = ({ children }) => {
  const location = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTo(0, 0);
  }, [location]);

  return <div>{children}</div>;
};

function App() {
  const location = useLocation();

  // Define paths where Footer SHOULD be displayed
  const showFooterPaths = ['/about', '/projects', '/scope'];

  // Check if current path should show footer OR if it's a project details page
  const shouldShowFooter =
    showFooterPaths.includes(location.pathname) ||
    location.pathname.startsWith('/project/');

  return (
    <>
      <PageWrapper>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/project/:id" element={<ProjectDetails />} />
          <Route path='/scope' element={<Scope />} />
          <Route path='/contact' element={<Contact />} />
        </Routes>
      </PageWrapper>

      {/* Conditionally render Footer */}
      {shouldShowFooter && <Footer showDesignCredit={location.pathname === '/about'} />}
    </>
  );
}

export default App;